export default __webpack_public_path__ + "static/media/playStore.5d9a8ea1.svg";